import { render, staticRenderFns } from "./CustomerDashIntro.vue?vue&type=template&id=aedb125a&scoped=true"
import script from "./CustomerDashIntro.vue?vue&type=script&lang=js"
export * from "./CustomerDashIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedb125a",
  null
  
)

export default component.exports